var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgEarRingR4 = function SvgEarRingR4(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: 25,
    height: 33,
    viewBox: "0 0 0.53 0.71",
    shapeRendering: "geometricPrecision",
    textRendering: "geometricPrecision",
    imageRendering: "optimizeQuality",
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".str0{stroke:#000;stroke-width:.11;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:22.9256}.fil0{fill:none}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_x0020_1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_2312514170976"
  }, /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.08.2C.11.15.18.12.25.12m.18.07c.02.04.04.08.04.15C.48.5.48.61.28.65.22.67.06.67.05.59"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    d: "M.32.32C.25.29.1.37.21.4.28.42.28.48.17.48.16.48.14.49.13.49"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.42.01c.05.04.07.08.06.12C.48.16.46.18.44.2.41.22.38.23.35.22.32.22.28.19.26.13.24.06.28.04.32.02L.33.01C.34.01.35 0 .37 0s.04 0 .05.01zM.39.07C.47.12.35.21.32.12.31.09.34.08.36.07.37.06.38.06.39.07z",
    fill: "#000"
  })))));
};

export default SvgEarRingR4;